import { isWeixin } from "../utils/tools"
const NODE_ENV = process.env.NODE_ENV;
let HOST = '', wssAddress = '', appid = '';
const appkey = isWeixin?'3085766248':'4319971435';
const secret = isWeixin?'Y08e2sz7rfQfD8Mal6EkIZD24DXAHiks':'ua3n7t4hy0zd1tgyl3gb3qw3ucdek450';

// if (NODE_ENV === 'development'){
//     //HOST = 'https://fuel.dev.chinawayltd.com';
//     HOST = '/api';
// }else if(NODE_ENV === 'test'){
//     HOST = 'https://fuel.test.chinawayltd.com';
// }else if(NODE_ENV === 'demo'){
//     HOST = 'https://fuel.demo.chinawayltd.com'
// }else if(NODE_ENV === 'production' || NODE_ENV === 'prod'){
//     HOST = 'https://fuel.huoyunren.com';
//     //HOST = 'https://fuel.test.chinawayltd.com';
// }else {
//     HOST = 'https://fuel.test.chinawayltd.com';  wx872ada4517304144
// }
if (window.location.host.indexOf('test') > -1) {
    HOST = 'https://fuel.test.chinawayltd.com';
    wssAddress='wss://notify.test.chinawayltd.com/api/notify/wsConnect/pdah5/';
    appid='wx872ada4517304144'
} else if(window.location.host.indexOf('demo') > -1) {
    HOST = 'https://fuel.demo.chinawayltd.com';
    wssAddress='wss://notify.test.chinawayltd.com/api/notify/wsConnect/pdah5/';
    appid='wx872ada4517304144'
} else if(window.location.host.indexOf('huoyunren') > -1|| window.location.host.indexOf('hbgszyht') > -1){
    HOST = 'https://fuel.huoyunren.com';
    wssAddress='wss://notify.huoyunren.com/api/notify/wsConnect/pdah5/';
    appid='wx3664e379767f44dc'
} else if(window.location.host.indexOf('localhost') > -1){
    HOST = '/api';
    wssAddress='wss://notify.test.chinawayltd.com/api/notify/wsConnect/pdah5/';
    appid='wx872ada4517304144'
} else {
    HOST = 'https://fuel.test.chinawayltd.com';
    wssAddress='wss://notify.test.chinawayltd.com/api/notify/wsConnect/pdah5/';
    appid='wx872ada4517304144'
}

/*// 一些全局的config配置
const modeUrlObj = {
    // 开发环境
    'development': {
        baseURL: 'https://pda.dev.chinawayltd.com',
        authBaseURL: ''
    },
    // 测试环境
    'test': {
        baseURL: 'https://pda.test.chinawayltd.com',
        authBaseURL: ''
    },
    // 预发布环境
    'demo': {
        baseURL: 'https://pda.demo.chinawayltd.com',
        authBaseURL: ''
    },
    // 生产环境
    'production': {
        baseURL: 'https://pda.huoyunren.com',
        authBaseURL: ''
    }
}

export default modeUrlObj[process.env.NODE_ENV]*/
export {
    HOST,
    NODE_ENV,
    appkey,
    secret,
    wssAddress,
    appid
}


